module.exports = __webpack_public_path__ + "img/26.28fd8a2f.svg";